import React from 'react'
import Alert from './Alert'
import Notifications from './Notifications'

const Alerts = ({ alert, notifications, dismiss, dismissNotification }) => (
  <>
    {!!notifications.length && <Notifications notifications={notifications} dismiss={dismissNotification} />}
    {alert && <Alert alert={alert} dismiss={dismiss} />}
  </>
)

export default Alerts
